export default "__VITE_ASSET__mhAMzxBZ__"